import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-115cc21e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "software-usage-wrap" }
const _hoisted_2 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 15px"}
}
const _hoisted_3 = {
  class: "cm-ui-dialog-title",
  style: {"padding":"25px 15px"}
}

import { ref, reactive, computed, onMounted, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import { ServicePermissionService } from '@/services/service-permission.service'
import Card from '@/views/dashboard/_components/card/card.vue'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import SoftwareActivityTrendChart from './_components/software-activity-trend-chart.vue'
import TimeProportionClassification from './_components/time-proportion-classification.vue'
import SoftwareUsageList from './_components/software-usage-list/software-usage-list.vue'
import type { SoftwareUsageListPreset } from './_components/software-usage-list/software-usage-list.vue'
import TerminalUsageList from './_components/terminal-usage-list/terminal-usage-list.vue'
import InstalledDetail from './_components/software-view/_components/installed-detail/installed-detail.vue'
import TerminalInstalledDetail from './_components/terminal-view/_components/installed-detail/installed-detail.vue'
import { SoftwareUsageData } from './_components/software-view/software-view.service'
import { SoftwareUsageData as TerminalUsageData } from './_components/terminal-view/terminal-view.service'
import { TableViewMode } from '@/views/dashboard/_enum/table-view-mode'
import dayjs from 'dayjs'
import { SoftManageService } from './service'
import { TimeRange } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { getTimeRangeByEnum } from '@/utils/time'
import { TimeGranularity, TimeFormat } from '@/views/dashboard/_components/time-range-select/time-range.enum'
import { formatTimeStamp } from '@/utils/time'

const hasPermission = true

// 统计数据

export default /*#__PURE__*/_defineComponent({
  __name: 'software-usage',
  setup(__props) {

const injector = useReflectiveInjector([SoftManageService])
const softManageService = injector.get(SoftManageService)
const servicePermissionService = injector.get(ServicePermissionService)
/** 软件管理/使用统计权益（与 software-manage 一致） */
const statistics = reactive({
  installedSoftwareCount: 0,
  todayActiveSoftware: 0,
  idleSoftware: 0,
  mostFrequentSoftware: '',
})

const { t, locale } = useI18n()
function classificationChartRangeToDateStrings(tr: TimeRange): [string, string] {
  const [startSec, endSec] = getTimeRangeByEnum(tr)
  if (startSec == null || endSec == null) {
    return threeMonthRange()
  }
  return [dayjs.unix(startSec).format('YYYY-MM-DD'), dayjs.unix(endSec).format('YYYY-MM-DD')]
}

function openSoftwareStatDrawer(preset: SoftwareUsageListPreset, initialSoftName?: string) {
  if (!hasPermission) return
  softwareDrawerClassificationRange.value = null
  softwareDrawerSoftGroupId.value = undefined
  softwareDrawerChartCategoryName.value = ''
  softwareDrawerListPreset.value = preset
  softwareDrawerInitialSoftName.value = (initialSoftName && initialSoftName.trim()) || ''
  softwareDrawerListKey.value += 1
  softwareDrawerVisible.value = true
}

/** 时长占比排行（statistics-events / RankingChart itemClick）：同图时间范围 + 软件分类筛参 */
function handleClassificationItemClick(payload: { groupId: number; name: string; percentage: number }) {
  if (payload.percentage <= 0) return
  softwareDrawerListPreset.value = 'all'
  softwareDrawerClassificationRange.value = classificationChartRangeToDateStrings(classificationTimeRange.value)
  softwareDrawerSoftGroupId.value = payload.groupId
  softwareDrawerChartCategoryName.value = payload.name
  softwareDrawerInitialSoftName.value = ''
  softwareDrawerListKey.value += 1
  softwareDrawerVisible.value = true
}

const statisticsItems = computed((): StatisticsCardItem[] => {
  void locale.value
  return [
    // {
    //   label: t('softwareUsage.installedCountLabel'),
    //   value: statistics.installedSoftwareCount,
    //   clickable: statistics.installedSoftwareCount > 0,
    //   events: {
    //     click: () => {
    //       if (statistics.installedSoftwareCount <= 0) return
    //       openSoftwareStatDrawer('all')
    //     }
    //   }
    // },
    {
      label: t('softwareUsage.todayActiveLabel'),
      value: t('softwareUsage.todayActiveSoftwareCount', { n: statistics.todayActiveSoftware }),
      clickable: statistics.todayActiveSoftware > 0,
      events: {
        click: () => {
          if (statistics.todayActiveSoftware <= 0) return
          openSoftwareStatDrawer('todayActive')
        }
      }
    },
    {
      label: t('softwareUsage.idleSoftwareLabel'),
      value: statistics.idleSoftware,
      clickable: statistics.idleSoftware > 0,
      events: {
        click: () => {
          if (statistics.idleSoftware <= 0) return
          openSoftwareStatDrawer('idle')
        }
      }
    },
    {
      label: t('softwareUsage.mostFrequentSoftwareLabel'),
      value: statistics.mostFrequentSoftware || '--',
      clickable: Boolean(statistics.mostFrequentSoftware),
      events: {
        click: () => {
          if (!statistics.mostFrequentSoftware) return
          openSoftwareStatDrawer('all', statistics.mostFrequentSoftware)
        }
      }
    }
  ]
})

// 图表数据
const activityTrendData = ref<{ times: string[]; counts: number[] }>({ times: [], counts: [] })
const classificationData = ref<Array<{ name: string; percentage: number; group_id?: number }>>([])
const activityTimeRange = ref<TimeRange>(TimeRange.DAYS_30)
const classificationTimeRange = ref<TimeRange>(TimeRange.DAYS_30)

// 软件列表 / 终端列表与详情抽屉共用时间范围：默认最近三个月（与 outbound-control-log-list 一致：`dateRange` + `useParseTime`）
function threeMonthRange (): [string, string] {
  return [dayjs().subtract(3, 'month').format('YYYY-MM-DD'), dayjs().format('YYYY-MM-DD')]
}
const softwareDrawerVisible = ref(false)
const softwareDrawerListKey = ref(0)
const softwareDrawerListPreset = ref<SoftwareUsageListPreset>('all')
/** 非 null 表示从时长占比图，日期区间与图一致 */
const softwareDrawerClassificationRange = ref<[string, string] | null>(null)
const softwareDrawerSoftGroupId = ref<number | undefined>(undefined)
const softwareDrawerChartCategoryName = ref('')
/** 打开软件列表抽屉时预填顶部搜索的软件名（如「使用频率最高」统计卡点击） */
const softwareDrawerInitialSoftName = ref('')
const softwareDateRange = ref<[string, string]>(threeMonthRange())

/** 闲置传空区间（`[]`），避免子组件 props 默认 `threeMonthRange` 在 `undefined` 时生效 */
const softwareDrawerDateRange = computed<[string, string] | []>(() => {
  if (softwareDrawerClassificationRange.value) {
    return softwareDrawerClassificationRange.value
  }
  if (softwareDrawerListPreset.value === 'todayActive') {
    const d = dayjs().format('YYYY-MM-DD')
    return [d, d]
  }
  if (softwareDrawerListPreset.value === 'idle') {
    return []
  }
  return threeMonthRange()
})

const softwareDrawerTitle = computed(() => {
  void locale.value
  const base = t('softwareUsage.softwareList')
  if (softwareDrawerChartCategoryName.value) {
    return `${base} [${softwareDrawerChartCategoryName.value}]`
  }
  if (softwareDrawerInitialSoftName.value) {
    return `${base} [${softwareDrawerInitialSoftName.value}]`
  }
  switch (softwareDrawerListPreset.value) {
    case 'todayActive':
      return `${base} [${t('softwareUsage.todayActiveLabel')}]`
    case 'idle':
      return `${base} [${t('softwareUsage.idleSoftwareLabel')}]`
    default:
      return base
  }
})

const terminalDrawerVisible = ref(false)
const terminalDateRange = ref<[string, string]>(threeMonthRange())

// 详情抽屉
const softwareDetailDrawerVisible = ref(false)
const currentSoftware = ref<SoftwareUsageData>({} as SoftwareUsageData)
const terminalDetailDrawerVisible = ref(false)
const currentTerminal = ref<TerminalUsageData>({} as TerminalUsageData)
const timeProportionClassificationRef = ref<{ loading?: boolean } | null>(null)

function viewAllSoftware() {
  if (!hasPermission) return
  openSoftwareStatDrawer('all')
}

function viewAllTerminals() {
  if (!hasPermission) return
  terminalDrawerVisible.value = true
}

function showSoftwareDetailDrawer(item: SoftwareUsageData) {
  currentSoftware.value = item
  softwareDetailDrawerVisible.value = true
}

function showTerminalDetailDrawer(item: TerminalUsageData) {
  currentTerminal.value = item
  terminalDetailDrawerVisible.value = true
}

// 图表时间范围变化
function handleActivityTrendTimeRangeChange(value: TimeRange) {
  activityTimeRange.value = value
  loadActivityTrendData()
}

function handleClassificationTimeRangeChange(value: TimeRange) {
  classificationTimeRange.value = value
  loadClassificationData()
}

// 加载统计数据
async function loadStatistics() {
  try {
    const res = await softManageService.getSoftmgrSoftUseStat({})

    statistics.installedSoftwareCount = res.install_count || 0
    statistics.todayActiveSoftware = res.active_count || 0
    statistics.idleSoftware = res.total_count || 0
    statistics.mostFrequentSoftware = res.max_times_soft || ''
  } catch (error) {
    console.error('加载统计数据失败:', error)
  }
}

// 加载图表数据
async function loadActivityTrendData() {
  try {
    const [start_time, end_time] = getTimeRangeByEnum(activityTimeRange.value)
    const granularity = TimeGranularity[activityTimeRange.value] || 'hour'

    const res = await softManageService.getSoftmgrSoftActivityStat({
      start_time: start_time.toString(),
      end_time: end_time.toString(),
      granularity
    })

    // 转换时间标签为显示格式
    const timeFormat = TimeFormat[activityTimeRange.value] || 'MM-DD HH:mm'
    const times = res.time_labels?.map(timestamp => {
      return formatTimeStamp(Number(timestamp), timeFormat)
    }) || []

    activityTrendData.value = {
      times,
      counts: res.usage_counts || []
    }
  } catch (error) {
    console.error('加载活跃度趋势数据失败:', error)
    activityTrendData.value = { times: [], counts: [] }
  }
}

async function loadClassificationData() {
  if (timeProportionClassificationRef.value) {
    timeProportionClassificationRef.value.loading = true
  }
  try {
    const [start_time, end_time] = getTimeRangeByEnum(classificationTimeRange.value)

    const res = await softManageService.getSoftmgrSoftTypeDurationStat({
      start_time: start_time.toString(),
      end_time: end_time.toString()
    })

    // 只取前6条数据
    classificationData.value = (res.list || []).slice(0, 6).map(item => ({
      name: item.group_name || t('genuineSoftwareUsage.unknown'),
      percentage: item.percentage || 0,
      group_id: item.group_id
    }))
  } catch (error) {
    console.error('加载分类数据失败:', error)
    classificationData.value = []
  } finally {
    if (timeProportionClassificationRef.value) {
      timeProportionClassificationRef.value.loading = false
    }
  }
}

onMounted(async () => {
  await nextTick()
  loadStatistics()
  loadActivityTrendData()
  loadClassificationData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(StatisticsCards, { items: statisticsItems.value }, null, 8, ["items"]),
    _createVNode(_component_el_row, {
      gutter: 16,
      class: "charts-row"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, { span: 16 }, {
          default: _withCtx(() => [
            _createVNode(SoftwareActivityTrendChart, {
              data: activityTrendData.value,
              onTimeRangeChange: handleActivityTrendTimeRangeChange
            }, null, 8, ["data"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, { span: 8 }, {
          default: _withCtx(() => [
            _createVNode(TimeProportionClassification, {
              ref_key: "timeProportionClassificationRef",
              ref: timeProportionClassificationRef,
              cardHeaderStyle: "margin-bottom:0",
              data: classificationData.value,
              onTimeRangeChange: handleClassificationTimeRangeChange,
              onItemClick: handleClassificationItemClick
            }, null, 8, ["data"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(Card, {
      size: "second",
      title: _ctx.$t('softwareUsage.softwareListTop10')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(SoftwareUsageList, {
          "view-mode": _unref(TableViewMode).preview,
          "has-permission": hasPermission,
          "date-range": softwareDateRange.value,
          onViewAll: viewAllSoftware,
          onDetail: showSoftwareDetailDrawer
        }, null, 8, ["view-mode", "date-range"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(Card, {
      size: "second",
      class: "cm-ui-mt16",
      title: _ctx.$t('softwareUsage.terminalListTop10')
    }, {
      titleAfter: _withCtx(() => [
        _createVNode(_component_el_tag, { size: "small" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.listPreviewRecent10')), 1)
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(TerminalUsageList, {
          "view-mode": _unref(TableViewMode).preview,
          "has-permission": hasPermission,
          "date-range": terminalDateRange.value,
          onViewAll: viewAllTerminals,
          onDetail: showTerminalDetailDrawer
        }, null, 8, ["view-mode", "date-range"])
      ]),
      _: 1
    }, 8, ["title"]),
    _createVNode(_component_el_drawer, {
      modelValue: softwareDetailDrawerVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((softwareDetailDrawerVisible).value = $event)),
      "destroy-on-close": "",
      size: "70%"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('softwareUsage.installedSoftwareTitle', { name: currentSoftware.value.soft_name })), 1),
        _createVNode(InstalledDetail, {
          "software-key": currentSoftware.value.soft_hash_key,
          "software-id": currentSoftware.value.soft_id,
          "software-name": currentSoftware.value.soft_name,
          "date-range": softwareDateRange.value,
          "has-permission": hasPermission
        }, null, 8, ["software-key", "software-id", "software-name", "date-range"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: terminalDetailDrawerVisible.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((terminalDetailDrawerVisible).value = $event)),
      size: "60%",
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('softwareUsage.terminalUsedTitle', { name: currentTerminal.value.computer_name })), 1),
        _createVNode(TerminalInstalledDetail, {
          "computer-name": currentTerminal.value.computer_name,
          "device-id": currentTerminal.value.device_id,
          "date-range": terminalDateRange.value,
          "has-permission": hasPermission
        }, null, 8, ["computer-name", "device-id", "date-range"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: softwareDrawerVisible.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((softwareDrawerVisible).value = $event)),
      size: "80%",
      "destroy-on-close": "",
      "append-to-body": "",
      title: softwareDrawerTitle.value
    }, {
      default: _withCtx(() => [
        (softwareDrawerVisible.value)
          ? (_openBlock(), _createBlock(SoftwareUsageList, {
              key: softwareDrawerListKey.value,
              "view-mode": _unref(TableViewMode).full,
              "has-permission": hasPermission,
              "date-range": softwareDrawerDateRange.value,
              "list-preset": softwareDrawerListPreset.value,
              "initial-soft-group-id": softwareDrawerSoftGroupId.value,
              "initial-soft-name": softwareDrawerInitialSoftName.value,
              style: {"padding":"10px 16px"},
              onDetail: showSoftwareDetailDrawer
            }, null, 8, ["view-mode", "date-range", "list-preset", "initial-soft-group-id", "initial-soft-name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_drawer, {
      modelValue: terminalDrawerVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((terminalDrawerVisible).value = $event)),
      size: "80%",
      title: _ctx.$t('softwareUsage.terminalList'),
      "destroy-on-close": ""
    }, {
      default: _withCtx(() => [
        _createVNode(TerminalUsageList, {
          "view-mode": _unref(TableViewMode).full,
          "has-permission": hasPermission,
          "date-range": terminalDateRange.value,
          style: {"padding":"10px 16px"},
          onDetail: showTerminalDetailDrawer
        }, null, 8, ["view-mode", "date-range"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})